import React from 'react';
import 'katex/dist/katex.min.css';
import { InlineMath, BlockMath } from 'react-katex';

interface LaTeXRendererProps {
  content: string;
  inline?: boolean;
}

export const LaTeXRenderer: React.FC<LaTeXRendererProps> = ({ content, inline = false }) => {
  try {
    if (inline) {
      return <InlineMath math={content} />;
    } else {
      return <BlockMath math={content} />;
    }
  } catch (error) {
    console.error('LaTeX rendering error:', error);
    return (
      <span className="text-red-500 bg-red-50 px-2 py-1 rounded text-sm">
        Erreur LaTeX: {content}
      </span>
    );
  }
};

interface LaTeXEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const LaTeXEditor: React.FC<LaTeXEditorProps> = ({ 
  value, 
  onChange, 
  placeholder = "Tapez votre formule LaTeX ici..." 
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium mb-2 block">
          Formule LaTeX
        </label>
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full p-3 border rounded-lg font-mono text-sm"
          rows={3}
        />
        <p className="text-xs text-muted-foreground mt-1">
          {`Exemple: x = \\frac{-b \\pm \\sqrt{b^2-4ac}}{2a}`}
        </p>
      </div>
      
      {value && (
        <div>
          <label className="text-sm font-medium mb-2 block">
            Aperçu
          </label>
          <div className="p-4 border rounded-lg bg-gray-50">
            <LaTeXRenderer content={value} />
          </div>
        </div>
      )}
    </div>
  );
};